import { type JSX, useMemo } from "react";
import t from "../../shared/translations";
import PerformanceTable from "../../shared/components/PerformanceTable";

interface ILeaderboard {
    id: string;
    name: string;
    mode: string;
    specifiedTasks: {
        id: string;
    }[];
    specifiedFeedbackTasks: {
        id: string;
    }[];
    rankings: {
        pathMembershipId: string;
        firstName: string;
        lastName: string;
        rank: number;
        miles: number;
    }[];
}

interface IProps {
    leaderboard: ILeaderboard;
    currentPlayerMembershipId: string;
}

function LeaderboardTable({ leaderboard, currentPlayerMembershipId }: IProps): JSX.Element {
    const columns = useMemo(
        () => [
            {
                key: "rank",
                label: t("player.performance.leaderboard-table-heading-rank"),
                render: (ranking) => ranking.rank,
            },
            {
                key: "player",
                label: t("player.performance.leaderboard-table-heading-player"),
                render: (ranking) => `${ranking.firstName} ${ranking.lastName}`,
            },
            {
                key: "miles",
                label: t("player.performance.leaderboard-table-heading-miles"),
                render: (ranking) => ranking.miles,
            },
        ],
        [],
    );

    return (
        <PerformanceTable
            columns={columns}
            rows={leaderboard.rankings}
            rowKey={(ranking) => ranking.pathMembershipId}
            highlightRow={(ranking) => ranking.pathMembershipId.toString() === currentPlayerMembershipId}
            showMore
        />
    );
}

export default LeaderboardTable;
